var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2487 20.1654H6.41536C2.7487 20.1654 1.83203 19.2487 1.83203 15.582V6.41536C1.83203 2.7487 2.7487 1.83203 6.41536 1.83203H7.79036C9.16536 1.83203 9.46789 2.23538 9.99039 2.93204L11.3654 4.76538C11.7137 5.22371 11.9154 5.4987 12.832 5.4987H15.582C19.2487 5.4987 20.1654 6.41536 20.1654 10.082V11.9154",
    stroke: "#0068FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6117 16.7927C10.4576 16.9485 10.4576 20.0652 12.6117 20.221H17.7084C18.3225 20.221 18.9276 19.9919 19.3767 19.5794C20.8892 18.2594 20.0825 15.6194 18.0934 15.3719C17.3784 11.0727 11.1634 12.7044 12.6301 16.8019",
    fill: "#0068FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6117 16.7927C10.4576 16.9485 10.4576 20.0652 12.6117 20.221H17.7084C18.3225 20.221 18.9276 19.9919 19.3767 19.5794C20.8892 18.2594 20.0825 15.6194 18.0934 15.3719C17.3784 11.0727 11.1634 12.7044 12.6301 16.8019",
    stroke: "#0068FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderCloud);
export default __webpack_public_path__ + "static/media/folder-cloud.f4173063d94843b67ba004c19e91c0d5.svg";
export { ForwardRef as ReactComponent };